import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data?.company) {
            datas.company_id = data?.company
        }
        if (data?.customer) {
            datas.customer_id = data?.customer
        }
        if (data.selectedTab) {
            datas.processed_to_wms = data.selectedTab
        }
        if (data.orderType) {
            datas.order_type = data.orderType
        }
        if (data.startDate) {
            datas.created_date = data.startDate
        }
    }
    return ApiService.get('/api/v1/ensemble/sales-order-hdr/', datas)
}
export const createApiRecord = data => ApiService.post('/api/v1/ensemble/sales-order-hdr/', data)
export const getApiRecord = id => ApiService.get(`/api/v1/ensemble/sales-order-hdr/${id}/`)
export const updateApiRecord = (id, data) => ApiService.put(`/api/v1/ensemble/sales-order-hdr/${id}/`, data)
export const deleteApiRecord = id => ApiService.delete(`/api/v1/ensemble/sales-order-hdr/${id}/`)

export const createApiOrderRecord = data => ApiService.post('/api/v1/ensemble/sales-order-dtl/', data)
export const getApiOrderRecord = data => ApiService.get(`/api/v1/ensemble/sales-order-dtl/`, data)
export const updateApiOrderRecord = (id, data) => ApiService.put(`/api/v1/ensemble/sales-order-dtl/${id}/`, data)
export const deleteApiOrderRecord = id => ApiService.delete(`/api/v1/ensemble/sales-order-dtl/${id}/`)

export const uploadApiOrderRecords = data => ApiService.filePost('/api/v1/meson-app/upload-shipment/', data)
export const uploadApiDataBoatRecords = data => ApiService.filePost('/api/v1/databot/upload-sales-order/', data)
export const uploadApiNetSuiteRecords = data => ApiService.filePost('/api/v1/netsuite/sales-order-import/', data)
export const uploadApiNext3plRecords = data => ApiService.filePost('/api/v1/next3pl/sales-order-import/', data)
export const getApiWarehouseData = data => ApiService.get('/api/v1/ensemble/sales-order-hdr/get_warehouse_list/', data)
export const uploadApiExtraDocuments = (id, data) =>
    ApiService.filePost(`/api/v1/ensemble/sales-order-hdr/${id}/upload_file/`, data)

export const getApiOrderTypeData = data => ApiService.get('/api/v1/ensemble/sales-order-hdr/get_order_type_list/', data)
